import axios from "axios";
import { saveAs } from "file-saver";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportInvoiceListTypes } from "redux/reducers/Reports/reportInvoiceList/types";

const { SET_REPORT_INVOICE_LIST_FILTERS } = reportInvoiceListTypes;
const qid = process.env.REACT_APP_QID_INVOICES;

export const getReportInvoiceListAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL_PAY}/invoices/report?qid=${qid}&start=${startDate}&end=${endDate}&stations=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_Listado_Facturación_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportInvoiceList'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportInvoiceList'));
    }
  };
};

export const setReportInvoiceListFilters = (key = "", value) => {
  return {
    type: SET_REPORT_INVOICE_LIST_FILTERS,
    payload: { value, key },
  };
};
